// @flow
export const SET_SITE_FILTER = 'SET_SITE_FILTER';
export const setSiteFilter = (filterString: string) => ({
  type: SET_SITE_FILTER,
  payload: filterString,
});
